<template>
  <div class="upload-card">
    <div class="text-xs-center">
      <v-btn color="red lighten-2 text-center" dark @click="activateLoader">
        Upload Image
      </v-btn>
    </div>

    <div ref="croppieCard" class="uploader">
      <form>
        <div class="dropbox">
          <input
            type="file"
            name="uploadFieldName"
            ref="fileUploader"
            @change="filesChange($event.target.files)"
            accept="image/*"
            class="input-file"
          />
        </div>
      </form>

      <v-container class="cropping-container">
        <v-row class="pt-5">
          <v-col cols="12">
            <div ref="croppieContainer"></div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import "croppie/croppie.css";
import Croppie from "croppie/croppie.js";
import firebase from "firebase/app";
import "firebase/storage";

export default {
  components: {},
  props: {
    width: {
      type: Number,
    },
    height: {
      type: Number,
    },
    path: {
      type: String,
    },
  },
  data: () => ({
    croppieObject: Object,
    file: {
      name: "",
      type: "",
    },
    fileList: {},
    croppingSRC: "",
    dialog: false,
    isInitial: true,
    isCropping: false,
    isSuccess: false,
  }),
  watch: {
    dialog: function(newValue, old) {
      if (!newValue) {
        this.reset();
      }
    },
  },
  methods: {
    activateLoader() {
      this.$refs.fileUploader.click();
    },
    async filesChange(fileList) {
      try {
        this.croppieObject.destroy();
      } catch (err) {}
      this.croppieObject = null;
      this.isInitial = false;
      this.isCropping = true;

      let self = this;

      if (!fileList.length) return;
      this.fileList = fileList;

      Array.from(Array(fileList.length).keys()).map((x) => {
        const objectURL = URL.createObjectURL(fileList[x]);
        self.croppingSRC = objectURL;
        self.file = fileList[x];
        this.croppieObject = new Croppie(this.$refs.croppieContainer, {
          viewport: {
            width: self.$props.width,
            height: self.$props.height,
          },
          boundary: {
            width: self.$props.width + 25,
            height: self.$props.height + 25,
          },
        });
        self.croppieObject
          .bind({
            url: self.croppingSRC,
            zoom: 0.5,
          })
          .then(() => {
            self.getResult();
          });
      });
    },
    getResult() {
      let self = this;
      var storageRef = firebase.storage().ref();

      this.croppieObject.result("base64").then((html) => {
        var imageRef = storageRef.child(
          "/" + self.$props.path + "/" + self.file.name + Date.now()
        );

        imageRef.putString(html, "data_url").then((snapshot) => {
          snapshot.ref.getDownloadURL().then((downloadURL) => {
            self.file = downloadURL;
            this.$parent.$emit("uploadDone", { url: downloadURL });
          });
        });

        this.reset();
      });
    },
    reset() {
      this.croppieObject.bind({
        url:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=",
      });
      this.$refs.fileUploader.value = "";
      this.dialog = false;
      this.croppingSRC = "";
      this.isInitial = true;
      this.isCropping = false;
      this.isSuccess = false;
    },
  },
};
</script>
<style lang="scss">
.upload-card {
  .cropping-container,
  .uploader {
    position: fixed;
    left: 100vw;
    overflow: hidden;
  }
}
</style>
